/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReelSymbol from '../Reel/Symbol';
import ReferencedComponent from '../Utility/Component/ComponentReference/ReferencedComponent';
import SymbolData from './SymbolData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Represents the set of symbols used in a slot game. */
@cc._decorator.ccclass
export default class SymbolSet extends ReferencedComponent
{
    @property()
    protected zIndex: number = 10;
    public get ZIndex(): number { return this.zIndex; }

    /** @hidden */
    private _symbolDataList: SymbolData[] = [];

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();

        this._symbolDataList = this.node.getComponentsInChildren(SymbolData);
        this._symbolDataList.forEach(symbol => symbol.Parent = this);
    }

    /**
     * Searches for [[SymbolData]] associated with the supplied ID.
     * @param id The symbol ID to search for.
     * @returns The [[SymbolData]], or null if none found.
     */
    public GetSymbolDataById(id: string): SymbolData
    {
        return this._symbolDataList.find((x) => x.SymbolId === id);
    }

    /**
     * Pre-loads all symbol animations onto a [[ReelSymbol]].
     * @param symbol The [[ReelSymbol]] to pre-load the animations on.
     */
    public CopyAllAnimationsForSymbol(symbol: ReelSymbol): void
    {
        this._symbolDataList.forEach((x) => x.CopyAnimationsForSymbol(symbol));
    }
}
